import * as moment from "moment";

export class CacheTime {
    public serviceOrderId: number;
    public isArrival: boolean;
    public time: string;//keep in DateTimeFormat //moment.Moment;//any;
    public timezone: number;
    public uptime: number;
    public synced: boolean;
    public restart: number;
    public negative: boolean;
    public oldTime: string;
    public patientServiceOrderId: number;

    constructor(
        serviceOrderId: number,
        isArrival: boolean,
        time: string, //keep in DateTimeFormat //moment.Moment,//any,
        timezone: number,
        uptime: number,
        synced: boolean,
        restart: number,
        negative: boolean,
        oldTime: string,
        patientServiceOrderId: number,
    ) {
        this.serviceOrderId = serviceOrderId;
        this.isArrival = isArrival;
        this.time = time;
        this.timezone = timezone;
        this.uptime = uptime;
        this.synced = synced;
        this.restart = restart;
        this.negative = negative;
        this.oldTime = oldTime;
        this.patientServiceOrderId = patientServiceOrderId;
    }
}